import { useState, useRef } from 'react';
import { useReportTemplateContext } from '../ReportTemplate/ReportTemplateContext';
import { ALWAYS_INCLUDE_TYPES } from '../../../assets/reportSectionDefinitions';

export default function SectionSelectionBlock({ data, onChange }) {
  const { sections } = useReportTemplateContext();
  const [savingIds, setSavingIds] = useState(new Set());
  const timers = useRef({});

  const optionalSections = sections.filter(s => !ALWAYS_INCLUDE_TYPES.includes(s.type));
  const hiddenIds = new Set((data?.hiddenSectionIds ?? []).map(Number));

  const toggle = (id) => {
    const next = new Set(hiddenIds);
    next.has(id) ? next.delete(id) : next.add(id);
    onChange({ hiddenSectionIds: [...next] });

    setSavingIds(prev => new Set([...prev, id]));
    if (timers.current[id]) clearTimeout(timers.current[id]);
    timers.current[id] = setTimeout(() => {
      setSavingIds(prev => { const s = new Set(prev); s.delete(id); return s; });
    }, 700);
  };

  if (!optionalSections.length) {
    return <p className="text-muted small">Ei piilotettavia osioita tässä raportissa.</p>;
  }

  return (
    <div className="ms-2">
      <div className="text-muted mb-2" style={{ fontSize: '0.72rem', textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: 600 }}>
        Sisällytettävät osiot raporttiin
      </div>
      {optionalSections.map(section => {
        const id = Number(section.id);
        return (
          <div key={id} className="form-check mb-1 d-flex align-items-center gap-2">
            <input
              className="form-check-input mt-0"
              type="checkbox"
              id={`ssb-${id}`}
              checked={!hiddenIds.has(id)}
              onChange={() => toggle(id)}
            />
            <label className="form-check-label" htmlFor={`ssb-${id}`}>
              {section.name}
            </label>
            {savingIds.has(id) && (
              <span className="spinner-border spinner-border-sm text-secondary" style={{ width: '0.75rem', height: '0.75rem', borderWidth: '0.1em' }} />
            )}
          </div>
        );
      })}
    </div>
  );
}
